import { useRecoilValue } from 'recoil'

import CardWithTabs from '../../../components/CardWithTabs'
import LineChart from '../../../components/LineChart'
import useLocationDateTimeForm from '../../../hooks/useLocationDateTimeForm'
import { ServiceAtom } from '../../../recoil/atoms'
import useGetStoreVisitCount from '../hooks/useGetStoreVisitCount'
import useGetStoreVisitCountUUDaily from '../hooks/useGetStoreVisitCountUUDaily'
import useGetStoreVisitCountUUDateRange from '../hooks/useGetStoreVisitCountUUDateRange'

interface Props {
  className?: string
}

function UserVisitPerformanceBasic({ className }: Props) {
  const { form } = useLocationDateTimeForm()
  const service = useRecoilValue(ServiceAtom)

  const { uniqueUsers, uniqueUsersLoading } = useGetStoreVisitCountUUDateRange({
    serviceId: service.value,
    siteId: form.siteId,
    floorId: form.floorId,
    siteGroupId: form.siteGroupId,
    fromDate: form.fromDate,
    toDate: form.toDate,
  })
  const { storeVisitCountUUDaily, storeVisitCountUUDailyLoading } = useGetStoreVisitCountUUDaily({
    serviceId: service.value,
    siteId: form.siteId,
    floorId: form.floorId,
    siteGroupId: form.siteGroupId,
    fromDate: form.fromDate,
    toDate: form.toDate,
  })
  const { storeVisitCount, storeVisitCountLoading } = useGetStoreVisitCount({
    serviceId: service.value,
    siteId: form.siteId,
    floorId: form.floorId,
    siteGroupId: form.siteGroupId,
    fromDate: form.fromDate,
    toDate: form.toDate,
  })

  return (
    <CardWithTabs
      className={className}
      title='アプリユーザー来訪分析'
      tabs={[
        {
          title: '来訪ユーザー数 (期間UU)',
          value: 'unique',
          latest: uniqueUsers?.currentPeriodSum ?? 0,
          oldest: uniqueUsers?.previousPeriodSum ?? 0,
          qty: '人',
          isLoading: uniqueUsersLoading,
        },
        {
          title: '来訪ユーザー数 (日別UU)',
          value: 'daily-unique',
          latest: storeVisitCountUUDaily?.currentPeriodValue ?? 0,
          oldest: storeVisitCountUUDaily?.previousPeriodValue ?? 0,
          qty: '人',
          children: (
            <LineChart
              groupLabel='来訪ユーザー数 (日別UU)'
              labels={storeVisitCountUUDaily?.storeVisitCountUUDailyDatas?.map((data) => data.date) ?? []}
              datas={storeVisitCountUUDaily?.storeVisitCountUUDailyDatas?.map((data) => data.value) ?? []}
              xAxisLabel=''
              yAxisLabel='(人)'
            />
          ),
          isLoading: storeVisitCountUUDailyLoading,
        },
        {
          title: '来訪ユーザー数 (総来訪数)',
          value: 'visit',
          latest: storeVisitCount?.currentPeriodValue ?? 0,
          oldest: storeVisitCount?.previousPeriodValue ?? 0,
          qty: '人',
          children: (
            <LineChart
              groupLabel='来訪ユーザー数 (総来訪数)'
              labels={storeVisitCount?.storeVisitCountDatas?.map((data) => data.date) ?? []}
              datas={storeVisitCount?.storeVisitCountDatas?.map((data) => data.value) ?? []}
              xAxisLabel=''
              yAxisLabel='(人)'
            />
          ),
          isLoading: storeVisitCountLoading,
        },
      ]}
    />
  )
}

UserVisitPerformanceBasic.defaultProps = {
  className: '',
}

export default UserVisitPerformanceBasic
